import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOut } from '@fortawesome/free-solid-svg-icons'

import logo from '../assets/images/logo.png';
import logoIcon from '../assets/images/logo_icon.png';

const NavigationComponent = ({sessionLeftMinutes}) => {

  const renderButton = () => {
    return(
      <>
        <img src={logoIcon} alt="" />
        <span className="breakLines">{localStorage.getItem('name')}<br/>{localStorage.getItem('surname')}</span>
      </>
    )
  }

  const renderUserDropdown = () => {
    return(
      <>
        <NavDropdown title={renderButton()} id="basic-nav-dropdown">
              <NavDropdown.Item href="https://klett.pl/panel-nauczyciela" target="_blank"><FontAwesomeIcon icon={faUser} /> Moje konto na Klett.pl</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/wyloguj"><FontAwesomeIcon icon={faSignOut} /> Wyloguj</NavDropdown.Item>
            
            </NavDropdown>
      </>
    )
  }

  return(
    <Navbar expand="lg" className="" fixed="top"> 
      <Container>
        <Navbar.Brand href="/"> 
          <img src={logo} alt="" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {localStorage.getItem('jwt') !== null && sessionLeftMinutes > 0 ? renderUserDropdown() : null} 
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )

}
export default NavigationComponent;